import { ErrorI } from '@tacans/shared-marketplace-layer';

export const isValidationError = (error: ErrorI) =>
    // TODO: move errorCode to constants or ENUM
    error.errorCode === 'Validate';
